var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExchangeMagix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 56,
    viewBox: "0 0 115 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_558_768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 0V28.0825C35 20.6542 27.998 18.8234 27.998 11.4651C27.998 6.91309 30.3929 2.70621 34.2741 0.42519L35 0Z",
    fill: "url(#paint0_radial_558_768)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.998 11.4651V22.565L14.004 12.2054V32.8646C14.004 34.0152 14.1718 35.0506 14.4879 36.0161L8.72531 31.7491C8.55248 31.6191 8.39447 31.484 8.24633 31.334H8.24139C2.53809 26.2367 2.2912 19.2936 7.00198 16.2972L6.28104 16.7224C2.38996 19.0085 0 23.2103 0 27.7624V27.9174C0 35.2807 6.99704 37.1115 6.99704 44.5399V33.1998L20.996 43.5594V22.8952C20.996 21.7547 20.8183 20.7092 20.4973 19.7338L26.2698 24.0057C26.4376 24.1407 26.5957 24.2808 26.7537 24.4259C32.457 29.5232 32.7039 36.5463 27.9931 39.5426L28.6943 39.1324C32.5952 36.8514 34.9951 32.6395 34.9951 28.0825C34.9951 20.6542 27.9931 18.8234 27.9931 11.4651H27.998Z",
    fill: "url(#paint1_radial_558_768)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.23631 31.329C2.533 26.2367 2.28611 19.2936 6.99689 16.2972V28.3176C6.99689 29.4581 7.45118 30.5386 8.23631 31.329Z",
    fill: "url(#paint2_radial_558_768)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7539 24.4259C32.4572 29.5182 32.7041 36.5463 27.9933 39.5427V27.5223C27.9933 26.3818 27.539 25.2163 26.7539 24.4259Z",
    fill: "url(#paint3_radial_558_768)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99704 44.5399C6.94272 49.0369 4.55277 53.1738 0.701185 55.4298L0 55.8399V27.9175C0 35.2808 6.99704 37.1116 6.99704 44.5399Z",
    fill: "url(#paint4_radial_558_768)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 56V27.9175C0 35.3458 7.00198 37.1766 7.00198 44.5349C7.00198 49.0869 4.60708 53.2938 0.725875 55.5748L0 56Z",
    fill: "url(#paint5_radial_558_768)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_558_768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 0V28.1227C35 20.6838 27.998 18.8503 27.998 11.4815C27.998 6.92298 30.3929 2.71008 34.2741 0.425798L35 0Z",
    fill: "url(#paint6_linear_558_768)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.998 11.4816V22.5974L14.004 12.223V32.9117C14.004 34.0639 14.1718 35.1009 14.4879 36.0677L8.72531 31.7947C8.55248 31.6644 8.39447 31.5292 8.24633 31.3789H8.24139C2.53809 26.2743 2.2912 19.3213 7.00198 16.3206L6.28104 16.7464C2.38996 19.0357 0 23.2436 0 27.8022V27.9575C0 35.3313 6.99704 37.1647 6.99704 44.6037V33.2474L20.996 43.6218V22.928C20.996 21.7859 20.8183 20.7389 20.4973 19.7621L26.2698 24.0401C26.4376 24.1754 26.5957 24.3156 26.7537 24.4609C32.457 29.5655 32.7039 36.5987 27.9931 39.5993L28.6943 39.1885C32.5952 36.9042 34.9951 32.6863 34.9951 28.1228C34.9951 20.6838 27.9931 18.8504 27.9931 11.4816H27.998Z",
    fill: "#3ECF8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.23631 31.3738C2.533 26.2742 2.28611 19.3212 6.99689 16.3206V28.3581C6.99689 29.5003 7.45118 30.5823 8.23631 31.3738Z",
    fill: "url(#paint7_radial_558_768)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7539 24.4608C32.4572 29.5604 32.7041 36.5986 27.9933 39.5992V27.5616C27.9933 26.4195 27.539 25.2523 26.7539 24.4608Z",
    fill: "url(#paint8_radial_558_768)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 56V27.8773C0 35.3163 7.00198 37.1497 7.00198 44.5185C7.00198 49.0771 4.60708 53.29 0.725875 55.5743L0 56Z",
    fill: "url(#paint9_radial_558_768)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.69 40H40.458V26.842H42.69L46.938 37.318L51.186 26.842H53.454V40H51.222V35.95C51.222 33.304 51.222 32.53 51.348 31.594L48 40H45.876L42.546 31.612C42.672 32.404 42.69 33.646 42.69 35.284V40ZM61.6402 40H59.2462L63.9982 26.842H66.3562L71.1082 40H68.6782L67.6162 36.958H62.7022L61.6402 40ZM64.8802 30.766L63.3862 35.014H66.9502L65.4382 30.766C65.3302 30.424 65.2042 30.028 65.1682 29.758C65.1142 30.01 65.0062 30.406 64.8802 30.766ZM82.0078 28.786C79.3978 28.786 77.9038 30.676 77.9038 33.52C77.9038 36.454 79.5958 38.056 82.0258 38.056C84.3118 38.056 85.6978 36.796 85.6978 34.69V34.636H81.7198V32.602H87.8398V40H85.8958L85.7518 38.488C85.0318 39.496 83.5378 40.198 81.7558 40.198C78.0658 40.198 75.4918 37.516 75.4918 33.466C75.4918 29.47 78.1018 26.626 82.0618 26.626C85.0678 26.626 87.3898 28.372 87.7678 31.054H85.3378C84.9238 29.506 83.5918 28.786 82.0078 28.786ZM96.7718 26.842V40H94.4678V26.842H96.7718ZM107.141 33.43L102.767 26.842H105.503L107.105 29.2C107.645 30.01 108.095 30.766 108.581 31.666L111.641 26.842H114.323L110.021 33.412L114.341 40H111.623L110.147 37.822C109.571 36.94 109.103 36.148 108.581 35.194L105.377 40H102.677L107.141 33.43Z",
    fill: "#3ECF8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.224 20H40.218V9.976H46.21V10.9H41.226V14.512H45.748V15.422H41.226V19.076H46.224V20ZM50.9587 15.002L47.4587 9.976H48.6487L50.5107 12.608C50.9867 13.28 51.3087 13.812 51.5467 14.26L54.4587 9.976H55.6207L52.1767 14.974L55.6767 20H54.4727L52.5687 17.312C52.2327 16.836 51.8267 16.22 51.5747 15.772L48.6487 20H47.4727L50.9587 15.002ZM61.0092 20.154C58.2092 20.154 56.3052 18.068 56.3052 14.988C56.3052 11.908 58.2372 9.808 61.0652 9.808C63.2212 9.808 64.9152 11.11 65.3212 13.098H64.2432C63.8232 11.656 62.5912 10.774 61.0232 10.774C58.8252 10.774 57.3552 12.454 57.3552 14.988C57.3552 17.508 58.8252 19.188 61.0232 19.188C62.6052 19.188 63.8652 18.334 64.2992 16.99H65.3772C64.9152 18.88 63.1652 20.154 61.0092 20.154ZM68.3384 20H67.3304V9.976H68.3384V14.442H73.7564V9.976H74.7504V20H73.7564V15.38H68.3384V20ZM77.4115 20H76.3895L80.0715 9.976H81.3175L85.0415 20H83.9915L83.0115 17.34H78.3915L77.4115 20ZM80.5615 11.39L78.6995 16.458H82.6895L80.8135 11.39C80.7715 11.25 80.7015 11.082 80.6875 10.984C80.6735 11.068 80.6175 11.25 80.5615 11.39ZM87.653 20H86.645V9.976H87.667L93.183 18.32V9.976H94.177V20H93.183L87.653 11.656V20ZM101.035 10.76C98.7254 10.76 97.2694 12.468 97.2694 15.03C97.2694 17.634 98.8094 19.216 101.063 19.216C102.743 19.216 104.381 18.404 104.381 15.996V15.478H100.755V14.582H105.333V20.014H104.535L104.437 18.418C103.905 19.412 102.645 20.168 101.021 20.168C98.1794 20.168 96.2194 18.124 96.2194 15.03C96.2194 11.964 98.1794 9.808 101.049 9.808C103.163 9.808 104.801 11.012 105.193 12.832H104.101C103.681 11.46 102.505 10.76 101.035 10.76ZM113.975 20H107.969V9.976H113.961V10.9H108.977V14.512H113.499V15.422H108.977V19.076H113.975V20Z",
    fill: "#3ECF8E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_558_768",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.779 6.05704) rotate(74.3437) scale(17.1813 9.1761)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#5BB888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#58B485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#51A87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#45956D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#357A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B6A4D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_558_768",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.5561 27.9477) rotate(45.7106) scale(18.2171 27.3192)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DC4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#73C09A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#5BB888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#55AE80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#45956D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#2D6B4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#2C6A4D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_558_768",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.90253 18.2123) rotate(82.062) scale(9.09179 5.56722)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BB888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#58B485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#51A87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#46956D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#367A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C6A4D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_558_768",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.9447 37.6359) rotate(-97.938) scale(9.1418 5.59784)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BB888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#58B485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#51A87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#46956D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#367A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C6A4D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_558_768",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.432021 48.2911) rotate(-106.467) scale(13.7167 8.54839)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88CDD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#85C9D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#7CBDC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#6EAAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#5A8FA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#406C89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E5476"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_558_768",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.168465 49.9557) rotate(-105.656) scale(17.1813 9.1761)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#5BB888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#58B485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#51A87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#45956D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#357A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B6A4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_558_768",
    x1: 34.9408,
    y1: 14.0263,
    x2: 30.38,
    y2: 17.1757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5BB888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#55B585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#45AD7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32A472"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_558_768",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.90253 18.2383) rotate(82.0732) scale(9.10455 5.56737)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BB888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#57B685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#4BB07F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#38A775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#32A472"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_558_768",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.0704 37.7906) rotate(-97.9268) scale(9.15463 5.598)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BB888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#57B685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#4BB07F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#38A775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32A472"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_558_768",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.660829 49.8034) rotate(-105.635) scale(17.2041 9.17706)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#5BB888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#57B685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4BB07F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#38A775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32A472"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_558_768"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 56,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_558_768"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangeMagix);
export default __webpack_public_path__ + "static/media/exchange_magix.f50ef891cbd55af749b8042221028f76.svg";
export { ForwardRef as ReactComponent };